<template>
    <div class="login-page">
        <div class="center-area">
            <a href="https://funnelish.com" class="app-logo"><img src="@/assets/img/funnelish-logo.svg"></a>

	        <div v-if="isShopifyRedirect && shopName">
		        <p class="shopify-redirect">Login or signup first to connect your Shopify store <b>{{shopName}}</b> to Funnelish.</p>
	        </div>

          <AuthMethods login/>

	        <div>
		        <input-field :icon="require('@/assets/img/input-email-icon.svg')"
		                     autocomplete="email" placeholder="Your email address" v-model="userLogin"/>

		        <input-field type="password" :icon="require('@/assets/img/input-password-icon.svg')"
		                     autocomplete="password" placeholder="Your password" v-model="userPassword"/>
	        </div>

          <p class="error" v-if="error">* {{ error }}</p>
          <v-button :loading="loading || loginProgress" class="login-btn" :disabled="!userLogin || !userPassword"
                    @click.prevent="logIn()" label="Log in to Funnelish"/>

          <router-link to="/password-recovery" class="forgot-pass">Forgot your password?</router-link>

                <div class="no-account">
                  <span>Don't have an account yet? </span>
	                <router-link to="/sign-up">Sign up</router-link>
                </div>
	        <div class="tos">
		        © 2023 Funnelish. All rights reserved.
		        <a href="https://funnelish.com/privacy" target="_blank">Privacy</a> and
		        <a href="https://funnelish.com/tos" target="_blank">terms</a>.
	        </div>

	        <v-spinner v-if="loginProgress" />

        </div>
        </div>
</template>

<script>

import AuthMethods from "@/components/auth/AuthMethods.vue"
import API from "@/api"
import VButton from "@/components/base/v-button";
import {identifyFullStory} from "@/helpers/trackers";
import InputField from "@/components/base/input-field";
import VSpinner from "@/components/base/v-spinner";

export default {
    name: "LogIn",
		title:"Login | Funnelish™",
    components: {
	    VSpinner,
	    InputField,
	    VButton,
        AuthMethods
    },
    mixins: [API],
    data: function() {
        return {
	        loginProgress: false,
	        loading: false,
          userLogin: '',
          userPassword: '',
          error: false,
	        isShopifyRedirect: false,
	        shopName:'',
        }
    },
    methods: {
        async logIn() {
        	try {
		        this.loading = true;
		        this.error = false;
		        let email = this.userLogin;
		        let pass = this.userPassword;

		        if (email.length && pass.length) {
			        var result = await this.signIn(email, pass);
			        if (result.status === 200) {
				        var token = result.data.access_token;

				        localStorage.setItem('user-token', token);
				        this.$store.dispatch('SET_TOKEN', token);

				        // var userRes = await this.getUsers();
				        var user = await this.api.users.me()
				        var userId = user.id;

				        localStorage.setItem('user', userId);
				        this.$store.dispatch('SET_USER', userId);

				        this.$store.dispatch('setUserInfo', user);

				        this.$store.state.accountId = user.id;
				        localStorage.setItem("accountId", user.id);

				        this.track();

				        this.$nextTick(() => {

									if (this.isShopifyRedirect && this.shopName) {
										this.$router.replace({path:'/integrations/5', query:this.$route.query})
									} else {
										window.location = '/' // force refresh.
									}
				        });

			        } else {
				        this.error = 'Incorrect login or password'
				        console.log(result);
			        }
		        }
	        } catch (e) {
		        this.$warn(e);
	        } finally {
		        this.loading = false;
	        }
        },
	    async track(userId, user) {
		    identifyFullStory(user)

        let event = "login";
        if (this.$route.query.signup)  {
        	event = "sign_up";
	        window.fbq('track', 'StartTrial', {
		        value: 1,
		        subscription_id: userId,
		        currency: 'USD',
	        });
        } else {

        }
		    this.$gtag.linker({
			    'accept_incoming': true,
			    'domains': ['funnelish.com','app.funnelish.com','docs.funnelish.com','community.funnelish.com','go.funnelish.com']
		    });
		    this.$gtag.event(event, {
			    'send_to': 'AW-823430941/5-8nCIGjpNYCEJ2e0ogD',
			    'event_category': "engagement",
			    'event_label': "method",
		    });
	    },
	    async authCallback() {
		    let error = this.$route.query.error;
		    let auth = this.$route.query.auth;

		    if (error) {
		    	this.error = error;
		    	this.logout();
		    } else if (auth) {
			    this.loginProgress = true;
		    	let userToken = this.$cookies.get(`user-token`);
			    console.log("login: has auth", auth)

			    // this.$cookies.remove(`user-token`); // delete token, just in case
					if (!userToken) {
						this.error = "Something went wrong!"
						this.loginProgress = false;
						return;
					}

			    let userId = this.$route.query.auth;
			    localStorage.setItem('user-token', userToken);
			    this.$store.dispatch('SET_TOKEN', userToken);
			    localStorage.setItem('user', userId||'');
			    this.$store.dispatch('SET_USER', userId);

			    var user = await this.api.users.me()
			    this.$store.dispatch('setUserInfo', user);

			    this.$store.state.accountId = user.id;
			    localStorage.setItem("accountId", user.id);

			    this.track(userId, user);

			    this.$nextTick(()=> {
				    this.loginProgress = false;

				    if (this.isShopifyRedirect && this.shopName) {
					    this.$router.replace({path:'/integrations/5', query:this.$route.query})
				    } else {
					    window.location = '/' // force refresh.
				    }
					});
		    } else {
			    console.log("login: no auth!")
			    this.logout();
		    }
	    },
	    logout(){
		    // TODO: instead of auto logout just redirect to dashboard, the user must logout explicitly.
		    localStorage.removeItem('user-token');
		    localStorage.removeItem("accountId");

		    this.$store.dispatch('SET_TOKEN', false);
		    this.$store.dispatch('SET_USER', false);
		    this.$store.dispatch('setUserInfo', false);
	    }
    },
	mounted() {
		if (this.$route.query.error) {
		    this.$nextTick(() => {
			    this.$notify({
				    group: 'main',
				    title: this.$route.query.error,
				    type: 'warn',
			    });
		    });
	    }
		if (this.$route.query['integration-redirect'] === '5') {
			// redirect from Shopify app install
			this.isShopifyRedirect = true;
			this.shopName = this.$route.query.shop || '';
		}
	},
	created() {
    let gclid = this.$cookies.get('funnelish-gclid');
    if (gclid) {
	    const query = { ...this.$route.query, gclid: gclid };
	    console.log("created: ", JSON.parse(JSON.stringify(query)))
	    this.$router.replace({ query });
    }
		this.authCallback();
	},

	// beforeRouteEnter (to, from, next) {
	// 	next(vm => {
	// 		// access to component instance via `vm`
	// 		vm.authCallback();
	// 	})
	// },
  // beforeCreate() {
  //   // TODO: instead of auto logout just redirect to dashboard, the user must logout explicitly.
  //   localStorage.removeItem('user-token');
  //   localStorage.removeItem("accountId");
	//
  //   this.$store.dispatch('SET_TOKEN', false);
  //   this.$store.dispatch('SET_USER', false);
  //   this.$store.dispatch('setUserInfo', false);
  // },
}
</script>
<style lang="scss" scoped>
.login-page {
	background: url(/img/bg-main.jpeg) bottom center;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 50px 10px;
	background-repeat: no-repeat;
	background-size: cover;

	.shopify-redirect {
		font-size: 14px;
		line-height: 1.6;
		text-align: center;
		margin-bottom: 20px;
		b {
			white-space: nowrap;
			text-decoration: underline dashed 1px;
			text-underline-offset: 4px;
		}
	}

	.login-link {
		position: absolute;
		top: 20px;
		right: 25px;
		font-size: 14px;
		color: grey;
		font-weight: 400;
		&:hover {
			text-decoration: underline;
		}
	}
	.app-logo {
		margin: 15px auto;
	}
	@media only screen and (max-width: 400px){
		.center-area {
			padding: 20px 5px !important;
		}
	}
	.center-area {
		position: relative;
		background: white;
		border-radius: 10px;
		box-shadow: 0 8px 20px 0 rgb(0 0 0 / 6%);
		display: flex;
		margin: auto;
		max-width: 500px;
		min-width: 200px;
		padding: 20px 30px;
		flex-direction: column;
	}
	.error {
		color: red;
	}
	.tos {
		margin-top: 20px;
		color: #919299;
		a {
			color: #919299 !important;
		}
	}
	a:not(.button) {
		font-size: 14px;
		color: $blue;
		&:hover {
			text-decoration: underline;
		}
	}
	.forgot-pass {
		font-size: 14px;
		color: $blue;
		margin: 15px;
		text-align: center;
	}
	.no-account {
		font-size: 14px;
		color: $black;
		margin: 15px;
		text-align: center;
	}
}

</style>

<style lang="scss">
.login-page {
	.login-btn {
		background: $sharp-blue;
		margin: 20px auto;
		width: 100%;
		display: flex;
		.label {
			margin: auto;
		}
	}
  .input-field {
	  height: 48px;
    margin-top: 15px;
    input {
      border-radius: 6px;
    }
    .icon {
      padding: 3px 8px 3px 8px;
    }
  }
}
</style>
